import React from 'react';

interface ModelSelectorPopoverProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectAll?: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}

export const ModelSelectorPopover: React.FC<ModelSelectorPopoverProps> = ({
  isOpen,
  onClose,
  onSelectAll,
  disabled = false,
  children
}) => {
  if (!isOpen) return null;

  return (
    <div data-component="ModelSelectorPopover">
      {/* Backdrop */}
      <div 
        data-flow="overlay"
        className="fixed inset-0 bg-black bg-opacity-50 z-40"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div data-flow="modal" className="fixed inset-0 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg shadow-2xl w-full max-h-[90vh] overflow-y-auto" style={{ width: '80vw' }}>
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-gray-200 sticky top-0 bg-white">
            <h3 className="text-lg font-semibold text-gray-900">Select AI Models</h3>
            <div className="flex items-center gap-3">
              {onSelectAll && (
                <button
                  type="button"
                  onClick={onSelectAll}
                  disabled={disabled}
                  className="px-3 py-1.5 text-sm font-medium text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Select All
                </button>
              )}
              <button
                type="button"
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
          
          {/* Content */}
          <div className="p-6">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
